export const resellerPermissions = (permission, bpSettings) => {
  const permissions = [
    {
      label: "customerAdd",
      value: "customerAdd",
      isChecked: permission?.customerAdd,
      disabled: false,
    },
    {
      label: "customerEdit",
      value: "customerEdit",
      isChecked: permission?.customerEdit,
      disabled: false,
    },
    {
      label: "addCustomerWithMobile",
      value: "addCustomerWithMobile",
      isChecked: permission?.addCustomerWithMobile,
      disabled: bpSettings?.addCustomerWithMobile,
    },
    {
      label: "monthlyFeeEdit",
      value: "monthlyFeeEdit",
      isChecked: permission?.monthlyFeeEdit,
      disabled: false,
    },
    {
      label: "createCustomerWithBalance",
      value: "createCustomerWithBalance",
      isChecked: permission?.createCustomerWithBalance,
      disabled: false,
    },
    {
      label: "updateCustomerBalance",
      value: "updateCustomerBalance",
      isChecked: permission?.updateCustomerBalance,
      disabled: false,
    },
    {
      label: "customerMikrotikPackageEdit",
      value: "customerMikrotikPackageEdit",
      isChecked: permission?.customerMikrotikPackageEdit,
      disabled: false,
      info: "customerMikrotikPackageEditInfo",
    },
    {
      label: "customerStatusEdit",
      value: "customerStatusEdit",
      isChecked: permission?.customerStatusEdit,
      disabled: false,
    },
    {
      label: "customerActive",
      value: "customerActive",
      isChecked: permission?.customerActive,
      disabled: false,
      info: "customerActiveInfo",
    },
    {
      label: "logicalInactive",
      value: "logicalInactive",
      isChecked: permission?.logicalInactive,
      disabled: false,
      info: "logicalInactiveInfo",
    },
    {
      label: "customerAutoDisableEdit",
      value: "customerAutoDisableEdit",
      isChecked: permission?.customerAutoDisableEdit,
      disabled: false,
    },
    {
      label: "bulkAreaEdit",
      value: "bulkAreaEdit",
      isChecked: permission?.bulkAreaEdit,
      disabled: !bpSettings?.bulkAreaEdit,
    },
    {
      label: "bulkCustomerStatusEdit",
      value: "bulkCustomerStatusEdit",
      isChecked: permission?.bulkCustomerStatusEdit,
      disabled: !bpSettings?.bulkStatusEdit,
    },
    {
      label: "bulkCustomerBillingCycleEdit",
      value: "bulkCustomerBillingCycleEdit",
      isChecked: permission?.bulkCustomerBillingCycleEdit,
      disabled: false,
    },
    {
      label: "bulkCustomerRecharge",
      value: "bulkCustomerRecharge",
      isChecked: permission?.bulkCustomerRecharge,
      disabled: !bpSettings?.bulkCustomerRecharge,
    },
    {
      label: "instantRechargeBillPrint",
      value: "instantRechargeBillPrint",
      isChecked: permission?.instantRechargeBillPrint,
      disabled: !bpSettings?.instantRechargeBillPrint,
    },
    {
      label: "billingCycleEdit",
      value: "billingCycleEdit",
      isChecked: permission?.billingCycleEdit,
      disabled: false,
    },
    {
      label: "singleCustomerNumberEdit",
      value: "singleCustomerNumberEdit",
      isChecked: permission?.singleCustomerNumberEdit,
      disabled: false,
    },
    {
      label: "dailyRechargeFeature",
      value: "dailyRechargeFeature",
      isChecked: permission?.dailyRechargeFeature,
      disabled: !bpSettings?.dailyRechargeFeature,
    },
    {
      label: "minusBalance",
      value: "minusBalance",
      isChecked: permission?.minusBalance,
      disabled: !bpSettings?.resellerMinusBalance,
    },
    {
      label: "customerDelete",
      value: "customerDelete",
      isChecked: permission?.customerDelete,
      disabled: false,
    },
    {
      label: "dailyResellerCustomerAutoConnection",
      value: "dailyResellerCustomerAutoConnection",
      isChecked: permission?.dailyResellerCustomerAutoConnection,
      disabled: false,
    },
    {
      label: "customerRecharge",
      value: "customerRecharge",
      isChecked: permission?.customerRecharge,
      disabled: false,
    },
    {
      label: "bulkCustomerPackageUpdate",
      value: "bulkCustomerPackageUpdate",
      isChecked: permission?.bulkCustomerPackageUpdate,
      disabled: false,
    },
    {
      label: "promiseDate",
      value: "promiseDate",
      isChecked: permission?.promiseDate,
      disabled: false,
    },
    {
      label: "oltUserMonitor",
      value: "oltUserMonitor",
      isChecked: permission?.oltUserMonitor,
      disabled: false,
    },
    {
      label: "trafficMonitor",
      value: "trafficMonitor",
      isChecked: permission?.trafficMonitor,
      disabled: !bpSettings?.trafficMonitor,
    },
    {
      label: "customerPackageUpgrade",
      value: "customerPackageUpgrade",
      isChecked: permission?.customerPackageUpgrade,
      disabled: false,
    },
    {
      label: "customerPackageDowngrade",
      value: "customerPackageDowngrade",
      isChecked: permission?.customerPackageDowngrade,
      disabled: false,
    },
  ];

  return permissions;
};
